import { Input, Range } from 'sonata-react-components';

import './distribution.scss';

import type { AdInterface } from 'sonata-static-storage/lib/schemas/ad/ad.schema';
import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

type Props = {
  ad: AdInterface;
  baseCurrency: BaseCurrencyInterface;
  budgetValue: string;
  error: boolean;
  onChangeRangeDistribution?: (value: number) => void;
  onChangeInputDistribution?: (value: string | FileList | null) => void;
  onChangeBudgetDistribution?: (value: string | FileList | null) => void;
};

export function Distribution({
  ad,
  baseCurrency,
  budgetValue,
  error,
  onChangeRangeDistribution,
  onChangeInputDistribution,
  onChangeBudgetDistribution
}: Props) {
  return (
    <div className="distribution">
      <Range
        className="distribution__range"
        id={`distribution-range-${ad.campaignName}`}
        key={`${ad._id}-${ad.distribution}`}
        max={100}
        min={0}
        onChange={() => {
          // FIX: Range onChange should be optional
        }}
        type="slider"
        value={ad.distribution}
      >
        <Range.Bar
          disabled={ad.deleted || !ad.visible}
          onAfterChange={(value: any) => onChangeRangeDistribution?.(value)}
        />
      </Range>
      <div className="distribution__inputsContainer">
        <Input
          className="distribution__weightInput"
          disabled={ad.deleted || !ad.visible}
          id={`${ad.creative}-distribution`}
          inputAdditionalProps={{
            max: 100,
            min: 0
          }}
          inputStatus={error ? 'wrong' : 'default'}
          name={`${ad.creative}-distribution`}
          notFloatingPlaceholder
          numberFormat="percentage"
          onChange={value => onChangeInputDistribution?.(value)}
          shape="squareUI"
          tiny
          type="number"
          value={ad.distribution}
        />
        <Input
          className="distribution__budgetInput"
          currencyConfig={baseCurrency}
          disabled={ad.deleted || !ad.visible}
          id={`${ad.creative}-budget`}
          name={`${ad.creative}-budget`}
          notFloatingPlaceholder
          numberFormat="currency"
          numberOfDecimals={3}
          onChange={value => onChangeBudgetDistribution?.(value)}
          shape="squareUI"
          tiny
          type="number"
          value={budgetValue}
        />
      </div>
    </div>
  );
}
